import { ERROR_CODE as c } from "../../constants/error.js";
import { useConfigContext as m } from "../../contexts/config/ConfigContext.js";
import { CustomError as i } from "../../errors/customError.js";
import C from "query-string";
import * as g from "ramda";
import { useState as f, useCallback as l } from "react";
const O = (u) => {
  const {
    url: n
  } = u, {
    config: r
  } = m(), [d, s] = f(!1), [p, h] = f(null), a = l(() => {
    const {
      fetchJson: t
    } = r;
    if (g.isNil(t))
      throw new i('config "fetchJson" is not defined', c.GENERAL.MISSING_CONFIG);
    return t.buildId;
  }, [r]);
  return {
    fetchJson: l(async () => {
      s(!0);
      const t = new Headers();
      t.append("content-type", "application/json"), t.append("cache-control", "no-cache");
      try {
        const o = await fetch(C.stringifyUrl({
          url: n,
          query: {
            buildId: a()
          }
        }), {
          method: "GET",
          headers: t
        });
        if (s(!1), o.ok) {
          const e = await o.json();
          return h(e), e;
        } else
          throw new i("Cannot fetch static json data", c.FETCH.CANNOT_FETCH_JSON);
      } catch (o) {
        console.error(o.message);
      }
      return null;
    }, [a, n]),
    data: p,
    loading: d
  };
};
export {
  O as default
};
//# sourceMappingURL=useFetchJson.js.map
